<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	//Stores
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	//Design system components
	import { Toggle, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);
	let settings = readDeviceSettings(id);
	let invert = settings[`${get_gen_2_component_channel_structure(device)}`].swap_inputs;
	let loading = false;

	const sentRequest = async (e: InputClickEvent) => {
		loading = true;
		invert = e.target.checked;
		const params = { id: device.channel, config: { swap_inputs: invert } };
		const res: SettingRequest = await gen2Request(
			device,
			`${get_gen_2_component_from_category(device)}.SetConfig`,
			params,
		);

		if (res.isok) {
			settings[`${get_gen_2_component_channel_structure(device)}`].swap_inputs = invert;
			devices_settings.update_devices_settings(id, settings);
			toast.open({ type: 'success', title: $format('swap_inputs_scc_toast') });
		} else {
			invert = !invert;
			toast.open({ type: 'danger', title: $format('invert_input_err_toast') });
		}
		loading = false;
	};
</script>

<Toggle size="m" disabled={loading} checked={invert} on:click={sentRequest} id="toggle-1niwmk2">
	{$format('label_enable')}
</Toggle>
